export const cropBoundsSelector = state => state.map.cropBounds;

export const zoomSelector = state => state.map.zoom
